import { render, staticRenderFns } from "./failed-invoices.vue?vue&type=template&id=552e9e5f"
import script from "./failed-invoices.vue?vue&type=script&lang=js"
export * from "./failed-invoices.vue?vue&type=script&lang=js"
import style0 from "./failed-invoices.vue?vue&type=style&index=0&id=552e9e5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports